import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import config from "../config"

axios.defaults.timeout = 30 * 1000;
axios.defaults.baseURL = config.serviceAddress;//正式
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//axios.defaults.headers.common['Authorization'] = "";
//axios.defaults.headers.common['token'] = "";
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;
Vue.prototype.qs = qs;
export default axios;